import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SalesInvoiceService } from "../../../services/salesinvoice.service";

@Component({
  selector: "addEditTrimsInvoice",
  templateUrl: "./addEditTrimsInvoice.html",
})
export class AddEditTrimsInvoiceComponent {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };
  qualityList: any;
  typeList: any;
  colorList: any;
  codeList: any;
  seasonList: any;
  widthList: any[];
  execApi: boolean = true;
  chekApi: boolean = true;


  invoicedata: any = {
    rate_type: "",
    invoice_type: "",
    corcharge: 0,
    // boxless: 0,
    taxper: 5,
    disper: 0,
    salesorder: false,
    rate: 0,
    // no_of_bundles: 0,
    remarks: '',
    narration: '',
    totAmount: '',
  };

  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  invoiceTypeList = ["ESTIMATE", "INVOICE"];
  rateTypeList = ["FLAT RATE", "DISCOUNT"];
  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];
  partyList: any;
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  to_sale_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.sale_type = val["sale_type"];
    this.to_sale_type = val["to_sale_type"];
    this.saveEvent = val["data"].tabevent;
    let invoicedata = Object.assign({}, val["data"]);
    console.log(val);
    this.invoicedata = invoicedata;
    // this.invoicedata.disper = invoicedata.disper;
    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      //  this.editInvoiceList();
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.oncheck(this.invoicedata.salesorder);
    }
    if (
      this.mode == "Convert" ||
      this.mode == "Edit" ||
      this.mode == "View" ||
      this.mode == "Restore"
    ) {
      console.log(this.mode, this.invoicedata)
      this.invoicedata.boxless = Number(this.invoicedata.boxless);
      this.editInvoiceList();
  
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: SalesInvoiceService,
    public datePipe: DatePipe,
    public toasterService: ToasterService
  ) {
    this.row = {
      //  po_id: 0,
      design_no: "",
      shade: "",
      quality: "",
      type: "",
      color: "",
      sample_cut: "NO",
      swatch_cut: "NO",
      act_color: "",
      width: "",
      qty: 0,
      mtrs: 0,
      rate: 0,
      amount: 0,
    };
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {

    this.getSeason();
    this.tableScroll();
    this.invoicedata.mode = this.mode;
    this.invoicedata.sales_type = this.sale_type;


    if (this.mode == "Add") {
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      this.invoicedata.taxper = 5;
      // this.invoicedata.boxless = 0;
      // this.invoicedata.no_of_bundles = 0;

      this.getAutoNumber();
      this.getSalesParty();

      //this.getAuto();
    }
    if (this.mode == "Convert") {
      this.convertAutoNumber();

      if (this.to_sale_type == "proformaWholesale") {

        this.invoicedata.taxper = 0;
      }

    }
  }
  ngAfterViewInit() {
    if (this.sale_type == "retail") {
      setTimeout(() => {
        $("#invoice_type").focus();
      }, 100);
    } else {
      setTimeout(() => {
        $("#partyname").focus();
      }, 100);
    }
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }
  convertAutoNumber() {

    let params = {
      trans_type: this.to_sale_type,
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };
    this.salesinvservice.getAutoNumber(params).then((res: any) => {
      res.auto_no;

      let checkdata = {
        inv_no: res.auto_no,
        sales_type: this.to_sale_type
      }

      this.salesinvservice.checkInvno(checkdata).then((res: any) => {


        this.invoicedata.invoiceno = res.invoiceno;
        this.invoicedata.convertno_dc_id = res.dc_id;
        this.invoicedata.convert_type = res.convert_type;
      });



    });
  }
  onEnterKeyPressed(nextEl: string) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 500);
    }
  }

  onGoToNextFld($event, fld, ind) {
    let nxtInd = ind;
    let nxtRow = $("#row-" + ind).next("tr");
    if (fld == "bar" && nxtRow.length == 0) {
      let rowdetail = Object.assign({}, this.row);
      nxtInd = nxtInd + 1;
      $("#" + "bar" + "-" + nxtInd).focus();
    } else {
      setTimeout(() => {
        let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
        a.removeClass("mat-autocomplete-visible");
        $("#" + fld + "-" + nxtInd).focus();
      }, 100);
    }
  }

  isRowEmpty(ind) {
    let data = this.data.invoiceList;
    for (let i = 0; i < data.length; i++) {
      if (data[i + 1].design_no != "") {
        return true;
      } else {
        return false;
      }
    }
  }
  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length > 0) {
          if (that.box == "YES") {
            that.invoicedata.boxless -= 10;
          }

          that.data.invoiceList.splice(ind, 1);
          that.calctot();
          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) { }
    );
  }
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }
  checkInd(evant, ind, all) {
    if (evant.target.checked) {
      this.listSelected.push(all.data.invoiceList[ind]);
    } else {
      for (var k = 0; k < this.listSelected.length; k++) {
        if (this.listSelected[k].barcode == all.data.invoiceList[ind].barcode) {
          this.listSelected.splice(k, 1);
          return;
        }
      }
    }
  }

  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  getAutoNumber() {
    if (this.sale_type == 'trimsinvoice') {
      this.sale_type = 'wholesale';
    }
    let params = {
      trans_type: this.sale_type,
      date: this.datePipe.transform(new Date(), "yyyy-MM-dd"),
    };

    if (this.sale_type == "wholesale" || this.sale_type == "proformaWholesale") {
      this.salesinvservice.getAutoNumber(params).then((res: any) => {

        let check_invno = res.auto_no;
        let data = {
          inv_no: check_invno,
          sales_type: this.sale_type
        }

        this.salesinvservice.checkInvno(data).then((res: any) => {


          this.invoicedata.invoiceno = res.invoiceno;
          this.invoicedata.convertno_dc_id = res.dc_id;
          this.invoicedata.convert_type = res.convert_type;
        });


      });
    }
    else {
      this.salesinvservice.getAutoNumber(params).then((res: any) => {
        this.invoicedata.invoiceno = res.auto_no;

      });
    }
  }
  getSalesParty() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
    };
    this.salesinvservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
      if (this.sale_type == "retail") {
        this.invoicedata.party_name = "RETAIL";
      }
      this.onSelectPartyName(this.invoicedata.party_name);
    });
  }

  getSeason() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      date: this.datePipe.transform(new Date(), "yyyy"),
      type: "invoice",
    };
    this.salesinvservice.getCurrentSeason(params).then((res: any) => {
      if (res.success) {
        this.partyCtrl.setValue(this.invoicedata["season"]);
        this.invoicedata.season = res.data.season;
      } else {
        swal("PLEASE PUT THE SEASON FIRST!");
      }
    });
  }
  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }
  
  // load the form datas into the table

  loadTable(formValues: any) {
    formValues.tabevent = undefined;
    if (formValues.description !== "" && formValues.tot_amount > 0) {
      this.chekApi == true;
      let row = Object.assign(
        {
          description: "",
          rate: "",
          qty: "",
          totAmount: "",
        },
        formValues);
      if (row.description !== "") {
        this.data.invoiceList.push(row);
        console.log(this.data.invoiceList);
        var bottom = document.querySelector("#salesTbody");
        setTimeout(() => {
          bottom.scrollTop = bottom.scrollHeight;
        }, 300);
        this.calctot();
        this.invoicedata.description = "";
        this.invoicedata.rate = "";
        this.invoicedata.qty = "";
        this.invoicedata.tot_amount = "";
      }else {
        this.chekApi == false;
        swal({
          title: "Please Enter correct Details",
          type: "warning",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 3000,
        });
      }

    } else {
      this.chekApi == false;
      swal({
        title: "Please Enter correct Details",
        type: "warning",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 3000,
      });
      return false;
    }
  }





  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season: id });
      this.invoicedata.season = fitem["season"];
      return fitem["season"];
    }
    return "";
  }

  oncheckemptyrow() {
    
    let design = this.data.invoiceList;
    let desList = [];
    for (let i = 0; i < design.length; i++) {
      if (design[i].design_no != "") {
        desList.push(design[i]);
      }
    }
    this.data.invoiceList = desList;
    if (this.invoicedata.requisition_no == undefined) {
      swal("Make sure that the party name, season and Requisition No entered");
    } else {
      this.onSaveInvoice();
    }
  }

  onSaveInvoice(): void {
    if (
      this.invoicedata.party_name == undefined ||
      this.invoicedata.season == undefined ||
      this.invoicedata.corcharge == null ||
      this.invoicedata.corcharge == undefined ||
      this.invoicedata.requisition_no == ""
    ) {
      swal("Make sure that the party name, order.no or season entered");
    } else {
      let params: any = Object.assign({}, this.invoicedata);
      params["tabevent"] = undefined;

      params["dcinvoice"] = JSON.stringify(this.data.invoiceList);

      let that = this;

      swal({
        title: "Are you sure to save this Invoice?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, save it!",
        cancelButtonText: "No, want to change",
      }).then(function () {
        that.isLoadMask = that.salesinvservice
          .saveUpdateTrimsInvoice(params)
          .then(function (res: any) {
            if (res.message == "Access Denied") {
              swal("ERROR", "<h2>INVOICE SCREEN ACCESS IS CLOSED !!</h2>", "error");
              return false
            }
            else {
              if (that.saveEvent) {
                that.saveEvent.emit();
              }
              if (res.success) {
                that.toasterService.pop({
                  bodyOutputType: 1,
                  type: "success",
                  title: "SUCCESS",
                  body: res.message,
                });
                if (that.mode == "Add") {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                } else {
                  let tabObj = {
                    action: "CloseTab",
                    params: {},
                  };
                  that.tabUpdateEvent.emit(tabObj);
                }
              } else {
                if (that.mode == "Restore") {
                  swal("Sorry! You can only restore the last invoice...");
                } else {
                  swal("ERROR", res.message, "error");
                }
              }
            }
          })
          .catch(function (error: any) {
            let res = JSON.parse(error._body);
            swal("ERROR", res.message, "error");
          });
      });
    }
  }

  calcBox() {
    if (this.box == "YES") {
      this.invoicedata.boxless += 10;
    }
  }
  onSelectInvoiceType(type) {
    if (type == "ESTIMATE") {
      this.invoicedata.disper = 100;
      this.invoicedata.taxper = 0;

    } else {
      this.invoicedata.disper = 0;
      this.invoicedata.taxper = 5;
    }
  }
  onSelectPartyName(name) {
    let partylist = _.filter(this.partyList, { name: name });

    if (this.mode == 'Edit') {
      return
    }
    else if (this.mode != "Convert") {
      this.invoicedata.agent_id = partylist[0]["agent_id"];
      this.invoicedata.party_id = partylist[0]["genLedid"];
      this.invoicedata.disper = 0;

      
      this.invoicedata.transport = partylist[0]["transport"];
    }
    this.box = partylist[0]["boxless"];

    if (this.mode == "Add") {
      if (this.sale_type == "retail") {
        $("#customer_name").focus();
      } else {
        $("#so_no").focus();
      }
    }

    let params = {
      party_id: this.invoicedata.party_id,
      party_name: name,
      season: this.invoicedata.season,
    };
    this.salesinvservice.getPartyOrderNumber(params).then((res: any) => {
      this.partyOrderno = res;
    });
  }
 
  editInvoiceList() {
    let params = {
      start: 0,
      limit: 100,
      page: 1,
      dcid: this.invoicedata.dcid,
    };
    this.salesinvservice.getTrimsDetList(params).then((res: any) => {
      this.data.invoiceList = res.data;
      console.log(res.data.disper);
      this.calctot();
      var bottom = document.querySelector("#salesTbody");
      bottom.scrollTop = bottom.scrollHeight;
    });
  }
  
  oncheck(ischeck) {
    if (ischeck == true || ischeck == "true") {
      this.invoicedata.salesorder = true;
    } else {
      this.invoicedata.salesorder = false;
    }
  }

  calctot() {
    let tqty = 0,
      tamt = 0;
    for (let i = 0; i < this.data.invoiceList.length; i++) {
      tqty += parseInt(this.data.invoiceList[i]["qty"]);
      this.invoicedata.totalQty = tqty;
      tamt += parseInt(this.data.invoiceList[i]["tot_amount"]);
      this.invoicedata.totalAmount = tamt;
    }

  }

  buttonStyle() {
    const style = {
      Position: "relative",
      left: "73%",
      bottom: "54px"
    };
    return style;
  }

  calcAmt(qty: any, rate: any) {
    this.invoicedata.tot_amount = qty * rate;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesInvoice/addEditTrimsInvoice.ts